// PKCE (RFC 7636) helpers.
//
// Cognito requires PKCE for SPA app clients (no client secret). The
// verifier is a high-entropy random string; the challenge is its
// SHA-256 hash, base64url-encoded. We send the challenge with the
// authorize request, hold the verifier locally across the redirect,
// then send the verifier with the token-exchange POST. Cognito
// recomputes the hash and rejects the exchange if it doesn't match.
//
// The `state` value is a separate CSRF guard — also random, also
// stashed locally, also echoed back in the callback URL.

const VERIFIER_BYTES = 32;
const STATE_BYTES = 16;

/** Browser/Node 20 cross-platform crypto.getRandomValues. */
function getRandomValues(out) {
    if (typeof globalThis.crypto?.getRandomValues === 'function') {
        return globalThis.crypto.getRandomValues(out);
    }
    throw new Error('No crypto.getRandomValues available');
}

function base64url(bytes) {
    let s = '';
    for (let i = 0; i < bytes.length; i++) s += String.fromCharCode(bytes[i]);
    // btoa is in browsers + Node 20.
    return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function randomVerifier() {
    const bytes = new Uint8Array(VERIFIER_BYTES);
    getRandomValues(bytes);
    return base64url(bytes);
}

export function randomState() {
    const bytes = new Uint8Array(STATE_BYTES);
    getRandomValues(bytes);
    return base64url(bytes);
}

export async function challengeFromVerifier(verifier) {
    const data = new TextEncoder().encode(verifier);
    const hash = await globalThis.crypto.subtle.digest('SHA-256', data);
    return base64url(new Uint8Array(hash));
}
